export default "__VITE_ASSET__d0545941__"